import React, { useState } from 'react';

type Props = {
    ClosePopup: Function;
    documentUrl: string;
};

export class LeadDocumentPopup extends React.Component<Props>
{
    constructor(props:any) {
        super(props); 
    }

    componentDidMount(){
        this.load();
    }

    async load(){
        console.log('LeadDocumentPopup', this.props.documentUrl)
    }

    closePopup = (status?: string)=>{
        this.props.ClosePopup(status);  
    }
    
    render() {
      return ( <>
        <div className="popup-wrapper">
            <section className="popup-window new-lead rtl">
                <div className="close-icon pointer" onClick={(e:any)=>this.closePopup()}></div>
                <div className="popup-content">
                    <div className="popup-header">
                        <div className="popup-title">
                        </div>
                    </div>
                    <div className="popup-body">
                        <iframe src={this.props.documentUrl} style={{width:'100%',height:'100%'}}></iframe>
                    </div>
                    <div className="popup-footer">
                        <button className="button white blue-border"  onClick={(e:any)=>this.closePopup()}>
                            סגור
                        </button>
                    </div>
                </div>
            </section>
        </div>
      </>  
        
      );
    }
  }